module.exports = __webpack_public_path__ + "static/media/icon.9ebb2e75.png";